const roleKeys = {
  owner: 'roles.owner', admin: 'roles.admin', school_admin: 'roles.schoolAdmin',
  teacher: 'roles.teacher', head_teacher: 'roles.headTeacher', student: 'roles.student',
  guardian: 'roles.guardian', member: 'roles.member',
} as const;

export function roleMessageKey(role: string): (typeof roleKeys)[keyof typeof roleKeys] | null {
  return roleKeys[role as keyof typeof roleKeys] ?? null;
}
